const memberInfoMap = {
    'acet.uhc.com': {
        subscriberInfo: {
            firstName: 'arcade.cache.profile.data.currentUser.userInfo.firstName',
            lastName: 'arcade.cache.profile.data.currentUser.userInfo.lastName',
            dateOfBirth: 'arcade.cache.profile.data.currentUser.userInfo.dob',
            age: 'arcade.cache.profile.data.currentUser.userInfo.age',
            state: 'arcade.cache.profile.data.currentUser.userInfo.state',
            zipCode: 'arcade.cache.profile.data.currentUser.userInfo.zipCode',
            memberId: '???',
        },
        patientInfo: {
            firstName: '',
            lastName: '',
            dateOfBirth: '', // yyyy-mm-dd
            age: 99,
            state: '',
        },
    },
    'prod.member.myuhc.com': {
        subscriberInfo: {
            firstName: {
                locationType: 'session',
                locationName: 'arcade.cache.profile.data.currentUser.userInfo.firstName',
            },
            lastName: {
                locationType: 'session',
                locationName: 'arcade.cache.profile.data.currentUser.userInfo.lastName',
            },
            dateOfBirth: {
                locationType: 'session',
                locationName: 'arcade.cache.profile.data.currentUser.userInfo.dob',
            },
            age: {
                locationType: 'session',
                locationName: 'arcade.cache.profile.data.currentUser.userInfo.age',
            },
            state: {
                locationType: 'session',
                locationName: 'arcade.cache.profile.data.currentUser.userInfo.state',
            },
            zipCode: {
                locationType: 'session',
                locationName: 'arcade.cache.profile.data.currentUser.userInfo.zipCode',
            },
            memberId: {
                locationType: 'localStorage',
                locationName: '???',
            },
            test: 'back',
        },
        patientInfo: {
            firstName: '',
            lastName: '',
            dateOfBirth: '', // yyyy-mm-dd
            age: 99,
            state: '',
        },
    },
    localhost: {
        subscriberInfo: {
            firstName: {
                locationType: 'session',
                locationName: 'memberInfo',
                key: 'data.fname',
            },
            lastName: {
                locationType: 'session',
                locationName: 'memberInfo',
                key: 'data.lname',
            },
            dateOfBirth: {
                locationType: 'session',
                locationName: 'memberInfo',
                key: 'data.dob[0]',
            },
            age: {
                locationType: 'session',
                locationName: 'age',
            },
            state: {
                locationType: 'session',
                locationName: 'memberInfo',
                key: 'data.state',
            },
            zipCode: {
                locationType: 'session',
                locationName: 'memberInfo',
                key: 'data.address[0].zipcode',
            },
            memberId: {
                locationType: 'localStorage',
                locationName: 'value.data.currentUser.planCoverages[0].coverageType',
            },
        },
        patientInfo: {
            firstName: {
                locationType: 'localStorage',
                locationName: 'memberInfo',
                key: 'data.fname',
            },
            lastName: {
                locationType: 'localStorage',
                locationName: 'memberInfo',
                key: 'data.lname',
            },
            dateOfBirth: {
                locationType: 'localStorage',
                locationName: 'memberInfo',
                key: 'data.dob',
            },
            age: {
                locationType: 'localStorage',
                locationName: 'age',
            },
            state: {
                locationType: 'localStorage',
                locationName: 'memberInfo',
                key: 'data.state',
            },
        },
    },
};

export { memberInfoMap };
